import { Box, Divider, Typography } from '@mui/material';
import EditIcon from '../../../icons/EditWhiteIcon.svg';
import { AnnouncementPersonalizationDto } from '@inosio/payments-sdk';

export interface PersonalizePopupToolbarProps {
  show?: boolean;
  selectedPersonalizedField?: AnnouncementPersonalizationDto;
  onEdit?: () => void;
  position?: { top: number; left: number };
}

export const PersonalizePopupToolbar = (props: PersonalizePopupToolbarProps) => {
  const position = props.position ?? { top: 0, left: 0 };
  return props.show ? (
    <Box
      sx={{
        color: '#fff',
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        padding: '5px 10px',
        borderRadius: '5px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        border: '1px solid #fff',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-8px', // Adjust the positioning to place it at the bottom
          left: '50%',
          transform: 'translateX(-50%)',
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '8px solid rgba(0, 0, 0, 0.9)', // Color of the chevron
        },
      }}
    >
      <Typography variant="body2">Fallback Value: {props.selectedPersonalizedField?.FallbackValue}</Typography>
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          margin: '0 10px',
          borderColor: '#9d9d9d', // Set the divider's color to white
        }}
      />
      <img src={EditIcon} style={{ cursor: 'pointer', fontSize: '18px', filter: 'grayscale(100%)' }} alt="Edit" onClick={props.onEdit} />
    </Box>
  ) : (
    <></>
  );
};
